<template>
  <div class="kpt-remotes-root kpt-list-page">
    <vue-headful :title="title" />
    <header class="kpt-list-header">
      <h4>Remotes</h4>
      <div class="page-control">
        <!-- <font-awesome-icon :icon="['far', 'thumbtack']" @click="pinToDash('remoteList', { name: 'Remote List' })" title="Pin to Dashboard" class="has-cursor-pointer" /> -->
      </div>
    </header>
    <div class="kpt-list-actions">
      <div class="buttons">
        <b-button tag="router-link" size="is-small" :to="{ name: 'remoteCreate' }" icon-left="plus" v-if="$hasRole('Super User,Kymeta Admin,Product Support,Account Admin,Credentialed')">
          Add Remote
        </b-button>
        <b-button size="is-small" icon-left="line-columns" @click="openContextPane">
          Table Settings
        </b-button>
        <b-button size="is-small" icon-left="file-export" :disabled="!(remotes.length)" :title="!(remotes.length) ? 'Export not available when no data is found.' : ''" @click="exportRemotes">
          Export CSV
        </b-button>
        <b-button size="is-small" icon-left="sync" @click="getRemotes">
          Refresh List
        </b-button>
        <!-- <b-button size="is-small" icon-left="map" @click="mapVisible = !mapVisible">
    View Map
  </b-button> -->
        <b-button tag="router-link" size="is-small" :to="{ name: 'optionFileValidator' }" icon-left="file-code" v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed')" class="ml-auto p-2 bd-highlight mr-5">
          Option File Validator
        </b-button>
      </div>
      
    </div>
    <div class="kpt-filter-bar">
      <b-input size="is-small" placeholder="Filter by remote name, description or serials" v-model="nameFilter" @keyup.native.enter="addFilter({ property: 'Name', comparator: 'eq', value: nameFilter })" style="width: 250px"></b-input>
      <div class="filter-list" v-if="filterTags.length">
        <b-taglist>
          <b-tag closable @close="deleteFilter(filter)" v-for="(filter, idx) in filterTags" :key="idx"><span class="is-capitalized">{{filter.property == 'Name' ? 'Query' : filter.property}}</span> {{filter.comparator}} <strong>{{filter.value}}</strong></b-tag>
        </b-taglist>
      </div>
      <add-table-filter :add-function="addFilter" :fields="filterableColumns"></add-table-filter>
    </div>
    <remote-map :selected-remotes="selectedRemotes" :remotes="remotes" v-if="mapVisible"></remote-map>
    <div class="kpt-list-table" :class="{ 'kpt-list-table-minimized': mapVisible }">
      <b-table
        :data="remotes"
         sticky-header
        :narrowed="true"
        :hoverable="true"
        :loading="isLoading"
        sort-icon="chevron-up"
        sort-icon-size="is-small"
        backend-sorting
        @sort="onSort"
        ref="remoteTable"
        class="has-horizontal-scroll is-full-height">
        <b-table-column  
        v-for="(column, index) in bTableColumns" :key="index"
        :field="column.field"
        :label="column.label"  
        :meta="column.meta"
        :visible="column.visible" 
        :sortable="isSortable(column.field)"
        :cell-class="cellClass(column.field)"
        :centered="isCentered(column.field)"
        :width="hasWidth(column.field)"
        >
        <template v-if="column.field=='satelliteOnline'"  v-slot:header="{ column }">
            <font-awesome-icon :icon="['far', 'satellite-dish']" title="Satellite Status" />
        </template>
        <template v-else-if="column.field=='cellularOnline'"  v-slot:header="{ column }">
            <font-awesome-icon :icon="['far', 'signal-stream']" title="Cellular Status" />
        </template>
        <template v-else  v-slot:header="{ column }">
           {{column.label}}
           <font-awesome-icon  :icon="['far', 'chevron-up']" v-if="sortBy==matchingSortBy(column.field) && sortDirection=='asc'"/>
           <font-awesome-icon  :icon="['far', 'chevron-down']" v-if="sortBy==matchingSortBy(column.field) && sortDirection=='desc'"/>
        </template>
        <template v-if="column.field=='satelliteOnline'"  v-slot:default="props" :title="props.row[column.label]">
            <font-awesome-icon :icon="['fas', 'circle']" class="has-text-success" v-if="props.row.satelliteOnline==true" title="Online" />
            <font-awesome-icon :icon="['far', 'circle']" class="has-text-danger" v-else-if="props.row.satelliteOnline==false" title="Offline" />
            <font-awesome-icon :icon="['fas', 'circle']" class="has-text-grey-light" v-else title="Unknown" />
        </template>
        <template v-else-if="column.field=='cellularOnline'"  v-slot:default="props"  :title="props.row[column.label]" >
            <font-awesome-icon :icon="['fas', 'circle']" class="has-text-success" v-if="props.row.cellularOnline==true" title="Online" />
            <font-awesome-icon :icon="['far', 'circle']" class="has-text-danger" v-else-if="props.row.cellularOnline==false" title="Offline" />
            <font-awesome-icon :icon="['fas', 'circle']" class="has-text-grey-light" v-else title="Unknown" />
        </template>
        <template v-else-if="column.field=='normalizedName'" v-slot="props">
           <router-link :to="{ name: 'remoteOverview', params: { id: props.row.id } }">{{props.row.name}}</router-link>
        </template>
        <template v-else-if="column.field=='normalizedAccountName'" v-slot="props">
            {{ props.row.accountName || getAccountNameFromId(props.row.accountId) }}
        </template>
        <template v-else-if="column.field=='normalizedBilledAccountName'" v-slot="props">
            {{ props.row.billedAccountName || getAccountNameFromId(props.row.billedAccountId) }}
        </template>
        <template v-else-if="column.field=='provisioned'" v-slot="props">
          <font-awesome-icon :icon="['far', 'check-circle']" class="has-text-success" v-if="props.row.provisioned" />
          <font-awesome-icon :icon="['far', 'times-circle']" class="has-text-grey" v-else />
        </template>
        <template v-else-if="column.field=='activated'" v-slot="props">
          <font-awesome-icon :icon="['far', 'check-circle']" class="has-text-success" v-if="props.row.activated" />
          <font-awesome-icon :icon="['far', 'times-circle']" class="has-text-grey" v-else />
        </template>
        <template v-else-if="column.field=='devices.modemSerial'" v-slot="props">
           {{ props.row.devices ? props.row.devices.modemSerial : '-' }}
        </template>
        <template v-else-if="column.field=='devices.antennaSoftwareVersion'" v-slot="props">
           {{ props.row.devices && props.row.devices.antennaSoftwareVersion ? props.row.devices.antennaSoftwareVersion : '-' }}
        </template>
        <template v-else-if="column.field=='devices.antennaTargetVersion'" v-slot="props">
           {{ props.row.devices && props.row.devices.antennaTargetVersion ? props.row.devices.antennaTargetVersion : '-' }}
        </template>
        <template v-else-if="column.field=='devices.antennaLastCheckin'" v-slot="props">
           {{ props.row.devices && props.row.devices.antennaLastCheckin ? format(new Date(props.row.devices.antennaLastCheckin), 'yyyy-MM-dd HH:mm') : '-' }}
        </template>
        <template v-else-if="column.field=='devices.cellRouterSerial'" v-slot="props">
           {{ props.row.devices && props.row.devices.cellRouterSerial ? props.row.devices.cellRouterSerial : '-' }}
        </template>
        <template v-else-if="column.field=='devices.cellRouterICCID'" v-slot="props">
           {{ props.row.devices && props.row.devices.cellRouterICCID ? props.row.devices.cellRouterICCID : '-' }}
        </template>
        <template v-else-if="column.field=='metrics.satDataUsed'" v-slot="props" >
          <span v-if="props.row.metrics && props.row.subscription" :class="ifUsageExceedsLimit(props.row.metrics.satDataUsed, props.row.subscription.maxDataLimitInGb)">
            {{ props.row.metrics ? `${$numeral(props.row.metrics.satDataUsed).format('0.00b')}` : '-' }}
          </span>
        </template>
        <template v-else-if="column.field=='metrics.cellDataUsed'" v-slot="props" >
          <span v-if="props.row.metrics && props.row.subscription" :class="ifUsageExceedsLimit(props.row.metrics.cellDataUsed, props.row.subscription.maxDataLimitInGb)">
            {{ props.row.metrics ? `${$numeral(props.row.metrics.cellDataUsed).format('0.00b')}` : '-' }}
          </span>
        </template>
        <template v-else-if="column.field=='subscription.maxDataLimitInGb'" v-slot="props">
          {{ props.row.subscription ? props.row.subscription.maxDataLimitInGb >= 0 ? `${props.row.subscription.maxDataLimitInGb} GB` : '-' : '-' }}
        </template>
        <template v-else-if="column.field=='subscription.hasSatellite'" v-slot="props">
          {{ props.row.subscription ? props.row.subscription.hasSatellite ? 'Yes' : 'No' : '-' }}
        </template>
        <template v-else-if="column.field=='subscription.hasCellular'" v-slot="props">
          {{ props.row.subscription ? props.row.subscription.hasCellular ? 'Yes' : 'No' : '-' }}
        </template>
        <template v-else-if="column.field=='groupNames'" v-slot="props">
          <span v-if="!props.row.groupIds">-</span>
          <span v-else-if="!props.row.groupIds.includes(',')">
            <router-link :to="{ name: 'groupOverview', params: { id: props.row.groupIds } }">{{props.row.groupNames}}</router-link>
          </span>
          <span v-else>
            <b-dropdown append-to-body trap-focus position="is-top-right">
              <span class="is-dash-underlined has-cursor-pointer has-text-grey" slot="trigger" role="button">
                <span>Multiple Groups</span>
              </span>
              <b-dropdown-item :focusable="false" custom paddingless>
                <ul class="kpt-sub-remote-list p-2">
                  <li v-for="group in getListOfGroups(props.row)" :key="group.id">
                    <router-link :to="{ name: 'groupOverview', params: { id: group.id } }">{{group.name}}</router-link>
                  </li>
                </ul>        
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </template>
        <template v-else-if="column.field=='devices.terminalModel'" v-slot="props">
           <span :title="props.row.devices ? idToName(props.row.devices.terminalModel, $store.state.devices.models) : ''">{{ props.row.devices ? idToName(props.row.devices.terminalModel, $store.state.devices.models) : '-' }}</span>
        </template>
        <template v-else-if="column.field=='devices.modemModel'" v-slot="props">
           {{ props.row.devices ? idToName(props.row.devices.modemModel, $store.state.devices.models) : '-' }}
        </template>
        <template v-else-if="column.field=='devices.cellRouterModel'" v-slot="props">
          {{ props.row.devices ? idToName(props.row.devices.cellRouterModel, $store.state.devices.models) : '-' }}
        </template>
        </b-table-column>
        <template slot="empty">
          <p>No remotes were found.</p>
        </template>
      </b-table>
    </div>
    <div class="kpt-list-footer">
      <list-pagination :total="count" :size="pageSize" :current="currentPage" @change="changePage"></list-pagination>
    </div>
  </div>
</template>
<script>
import { orderBy, flatMap } from 'lodash';
import { format } from 'date-fns';
import AddTableFilter from '../shared/AddTableFilterComponent.vue';
import ListPagination from '../shared/ListPaginationComponent.vue';
import { filterBuilderMixin } from '../shared/mixins/filterBuilder';
import { pinToDashMixin } from '../shared/mixins/pinToDash';
import { idToNameParserMixin } from '../shared/mixins/idToNameParser';
import { exportCsvMixin } from '../shared/mixins/exportCsvMixin';
import RemoteMap from './components/RemoteMapComponent.vue';
import { getModelsForTypeMixin } from '../shared/mixins/getModelForDeviceTypeMixin';
import { getListOfGroupsMixin } from '../shared/mixins/getListOfGroupsMixin';

export default {
  data() {
    return {
      selectedRemotes: [],
      filterTags: [],
      currentPage: 1, // reset to 1 when filter is applied
      pageSize: 50, // filled at Created
      sortBy: 'NormalizedName',
      sortDirection: 'asc',
      nameFilter: '',
      hiddenColumns: [],
      visibleColumns: [],
      allColumns: [],
      mapVisible: false,
      booleanSelection: [{ id: true, name: 'Yes' }, { id: false, name: 'No' }],
      onlineSelection: [{ id: true, name: 'Online' }, { id: false, name: 'Offline' }],
      cellNetworks: [{ id: 'Cubic', name: 'Cubic' }],
      format,
      reorderedColumns: []
    }
  },
  components: {
    AddTableFilter,
    ListPagination,
    RemoteMap
  },
  mixins: [filterBuilderMixin, pinToDashMixin, idToNameParserMixin, exportCsvMixin, getModelsForTypeMixin, getListOfGroupsMixin],
  async mounted() {
    this.pageSize = this.fetchTableSetting('remotes', 'pageSize');
    this.hiddenColumns = this.fetchTableSetting('remotes', 'hiddenColumns') || [];
    this.reorderedColumns = this.fetchTableSetting('remotes', 'reorderedColumns') || [];
    await this.getRemotes();
    this.figureOutVisibleColumns();
  },
  computed: {
    remotes() {
      return this.$store.state.remotes.remotes;
    },
    isLoading() {
      return this.$store.state.remotes.remotesLoading;
    },
    title() {
      return this.$route.name;
    },
    count() {
      return this.$store.state.remotes.count;
    },
    mapboxKey() {
      return this.$store.state.appConfig.mapboxKey;
    },
    userListSettings() {
      return this.$store.state.user.settings.userListSettings;
    },
    activeTableVisibleColumns() {
      return this.$store.state.system.activeTableVisibleColumns;
    },
    activeTablePageSize() {
      return this.$store.state.system.activeTablePageSize;
    },
    activeTableReorderedColumns() {
      return this.$store.state.system.activeTableReorderedColumns;
    },
    // Used for filters
    accounts() {
      return this.$store.state.accounts.accounts.map(a => ({ id: a.name, name: a.name }));
    },
    filterableColumns() {
      // return this.visibleColumns.filter(v => { return v.key.toLowerCase() != 'name' && !v.key.toLowerCase().includes('serial') && !v.key.toLowerCase().includes('date') && !v.key.toLowerCase().includes('dataused') });
      return this.visibleColumns.filter(v => v.filterable);
    },
    satNetworks() {
      return [{ id: 'Kymeta Broadband', name: 'Kymeta Broadband' }, { id: 'IntelSat FlexMove', name: 'IntelSat FlexMove' }, { id: 'KALO', name: 'KĀLO' }, { id: 'Lepton Global', name: 'Lepton Global' }]
    },
    allSoftwareVersions() {
      if (!this.$store.state.devices.versions) return [];
      const versions = [];
      const software = flatMap(this.$store.state.devices.versions, (value) => value.allowedVersions);
      software.forEach(s => {
        if (!versions.includes(s.version)) versions.push(s.version);
      })
      return orderBy(versions.map(v => ({ id: v, name: v }), ['id'], ['desc']));
    },
    bTableColumns() {
      const data = []; 
      if (this.reorderedColumns?.length > 0) { 
        this.reorderedColumns.forEach(el => {
          data.push({
            field: el.key,
            label: el.value,
            meta: el.meta,
            visible: (this.activeTableVisibleColumns.filter(avc => avc.key == el.key)?.length > 0)
          })
        });
      } else {
        data.push({
          field: 'satelliteOnline',
          label: 'Satellite Online',
          meta: {
            field: 'SatelliteOnline',
            selectable: this.onlineSelection
          },
          visible: true
        });
        data.push({
          field: 'cellularOnline',
          label: 'Cellular Online',
          meta: {
            field: 'CellularOnline',
            selectable: this.onlineSelection
          },
          visible: true
        });
        data.push({
          field: 'normalizedName',
          label: 'Name',
          meta: {
            field: 'Name'
          },
          visible: true
        });
        data.push({
          field: 'normalizedAccountName',
          label: 'Account',
          meta: {
            field: 'AccountName',
            selectable: this.accounts
          },
          visible: true
        });
        data.push({
          field: 'normalizedBilledAccountName',
          label: 'Billed Account',
          meta: {
            field: 'BilledAccountName',
            selectable: this.accounts
          },
          visible: true
        });
        data.push({
          field: 'provisioned',
          label: 'Provisioned',
          meta: {
            field: 'Provisioned',
            selectable: this.booleanSelection
          },
          visible: true
        });
        data.push({
          field: 'activated',
          label: 'Activated',
          meta: {
            field: 'Activated',
            selectable: this.booleanSelection
          },
          visible: true
        });
        data.push({
          field: 'devices.modemSerial',
          label: 'Modem SN',
          meta: {
            field: 'Devices/ModemSerial'
          },
          visible: true
        });
        data.push({
          field: 'devices.antennaSoftwareVersion',
          label: 'Antenna SW Version',
          meta: {
            field: 'Devices/AntennaSoftwareVersion',
            selectable: this.allSoftwareVersions
          },
          visible: true
        });
        data.push({
          field: 'devices.antennaTargetVersion',
          label: 'Target Version',
          meta: {
            field: 'Devices/AntennaTargetVersion',
            selectable: this.allSoftwareVersions
          },
          visible: true
        });
        data.push({
          field: 'devices.antennaLastCheckin',
          label: 'Last Checkin',
          meta: {
            field: 'Devices/AntennaLastCheckin'
          },
          visible: true
        });
        data.push({
          field: 'devices.cellRouterSerial',
          label: 'Router SN',
          meta: {
            field: 'Devices/CellRouterSerial'
          },
          visible: true
        });
        data.push({
          field: 'devices.cellRouterICCID',
          label: 'ICCID',
          meta: {
            field: 'Devices/CellRouterICCID'
          },
          visible: true
        });
        data.push({
          field: 'metrics.satDataUsed',
          label: 'Sat Data Used',
          meta: {
            field: 'Metrics/SatDataUsed'
          },
          visible: true
        });
        data.push({
          field: 'metrics.cellDataUsed',
          label: 'Cell Data Used',
          meta: {
            field: 'Metrics/CellDataUsed'
          },
          visible: true
        });
        data.push({
          field: 'subscription.maxDataLimitInGb',
          label: 'Usage Limit',
          meta: {
            field: 'Subscription/MaxDataLimitInGb'
          },
          visible: true
        });
        data.push({
          field: 'subscription.hasSatellite',
          label: 'Has Sat',
          meta: {
            field: 'Subscription/HasSatellite',
            selectable: this.booleanSelection
          },
          visible: true
        });
        data.push({
          field: 'subscription.hasCellular',
          label: 'Has Cell',
          meta: {
            field: 'Subscription/HasCellular',
            selectable: this.booleanSelection
          },
          visible: true
        });
        data.push({
          field: 'groupNames',
          label: 'Groups',
          meta: {
            field: 'GroupNames'
          },
          visible: true
        });
        data.push({
          field: 'devices.terminalModel',
          label: 'Terminal Model',
          meta: {
            field: 'Devices/TerminalModel',
            selectable: this.remapDeviceModels('DEV_TRMNL')
          },
          visible: true
        });
        data.push({
          field: 'devices.modemModel',
          label: 'Modem Model',
          meta: {
            field: 'Devices/ModemModel',
            selectable: this.remapDeviceModels('DEV_MODEM')
          } 
        });
        data.push({
          field: 'devices.cellRouterModel',
          label: 'Router Model',
          meta: {
            field: 'Devices/CellRouterModel',
            selectable: this.remapDeviceModels('DEV_CLRTR')
          },
          visible: true
        });
      } 
      return data;
    },
    appConfig() {
      return this.$store.state.appConfig;
    }
  },
  watch: {
    activeTableVisibleColumns(newvalue) {
      this.visibleColumns = newvalue;
      this.hiddenColumns = this.allColumns.filter(d => this.visibleColumns.find(z => d.key == z.key) == null);
    },
    activeTablePageSize(newvalue) {
      this.pageSize = newvalue;
      this.currentPage = 1;
      this.getRemotes();
    },
    activeTableReorderedColumns() {
      this.reorderedColumns = this.activeTableReorderedColumns;
    }
  },
  methods: {
    openContextPane() {
      this.$store.commit('setContextPane', 'columnEditor');
    },
    deleteFilter(filter) {
      this.filterTags = this.filterTags.filter(t => t.property != filter.property);
      this.getRemotes();
      // KyAnalytics client plugin, event tracker
      this.$kya.event('remotes', 'deleteRemotesFilter', 'Deleted remotes list filter', filter);
    },
    addFilter(filter) {
      const existingFilter = this.filterTags.find(t => t.property === filter.property);
      if (existingFilter) return;
      this.filterTags.push(filter);
      this.currentPage = 1;
      this.getRemotes();
      this.nameFilter = '';
      // KyAnalytics client plugin, event tracker
      this.$kya.event('remotes', 'addRemotesFilter', 'Added remotes list filter', filter);
    },
    changePage(page) {
      this.currentPage = page;
      this.getRemotes();
    },
    onSort(field, order) {
      const currentSortColumn = this.visibleColumns.find(c => c.key == field);
      if (!currentSortColumn.meta.field) console.error(`[onSort] Field not found: ${field}`);
      this.sortBy = currentSortColumn.meta.field.includes('Name') ? `Normalized${currentSortColumn.meta.field}` : currentSortColumn.meta.field;
      this.sortDirection = order;
      this.getRemotes();
    },
    async getRemotes() {
      const filterString = this.buildFilter(this.filterTags);
      if (!this.pageSize) this.pageSize = 50;
      await this.$store.dispatch('fetchRemotes', { 
        from: (this.currentPage - 1) * this.pageSize, 
        take: this.pageSize, 
        filters: filterString, 
        sortBy: this.sortBy, 
        sortDirection: this.sortDirection 
      });
    },
    isVisible(columnName) {
      return !this.hiddenColumns.find(c => c.key == columnName);
    },
    getListOfGroups(row) {
      if (!row.groupIds || !row.groupNames) return [];
      const groupIdArray = row.groupIds.split(',');
      const groupNameArray = row.groupNames.split(',');
      const returnArray = [];
      for (let i = 0; i < groupIdArray.length; i++) {
        returnArray.push({
          id: groupIdArray[i],
          name: groupNameArray[i]
        });
      }
      return returnArray;
    },
    figureOutVisibleColumns() {
      try {
        if (!this.$refs.remoteTable) return;
        this.allColumns = this.$refs.remoteTable.newColumns.map(c => ({ 
          key: c.field, 
          value: c.label, 
          meta: c.meta, 
          filterable: c.meta ? c.meta.selectable : false 
        }));
        // we have hidden columns, which means we have settings for this table
        if (this.hiddenColumns) {
          const visible = this.allColumns.filter(d => this.hiddenColumns.find(z => d.key == z.key) == null);
          if (!visible.length) {
            this.visibleColumns = this.allColumns;
          } else {
            this.visibleColumns = visible;
          }
        }
        
        this.$store.commit('setActiveTableProperties', { 
          table: 'remotes', 
          columns: this.allColumns, 
          pageSize: this.pageSize, 
          visibleColumns: this.visibleColumns,
          reorderedColumns: this.activeTableReorderedColumns
        });
      } catch (ex) {
        console.error(`Error encountered while attempting to figure out visible columns.`, ex);
      }
    },
    fetchTableSetting(tableName, settingName) {
      const table = this.$store.state.user.settings.userListSettings.find(r => r.table == tableName);
      return table ? table[settingName] : null;
    },
    remapDeviceModels(type) {
      return this.getModelsForType(type, this.$store).map(t => ({ id: t.shortcode, name: t.name }));
    },
    remapSubscriptionMetadata(metadata) {
      return metadata.map(m => ({ id: m.shortcode, name: m.name }));
    },
    async remapRemotesForExport() {
      const visibleColumns = this.activeTableVisibleColumns.map(c => c.key);
      const payload = {
        from: 0,
        take: this.count,
        filters: this.buildFilter(this.filterTags),
        sortBy: this.sortBy,
        sortDirection: this.sortDirection,
        bypassState: true
      };
      const data = await this.$store.dispatch('fetchRemotes', payload);
      // check for any errors
      if (data.isError) {
        // check for any errors
        this.$buefy.toast.open({
          duration: 3000,
          message: data.ex.message,
          type: 'is-danger'
        });
        return null;
      }
      const remotes = data.payload;
      const dataToExport = [];
      if (!!remotes && !!(remotes.length)) {
        remotes.forEach(remote => {
          const item = [];
          visibleColumns.forEach(col => {
            const isColVisible = visibleColumns.indexOf(col) > -1;
            if (col.includes('devices')) {
              if (remote?.devices && col.includes('antennaLastCheckin')) {
                item.push(remote?.devices?.[this.colEle2(col)] && isColVisible ? format(new Date(remote?.devices?.[this.colEle2(col)]), ' yyyy-MM-dd HH:mm') : '');
              } else {
                item.push(remote?.devices && isColVisible ? remote?.devices?.[this.colEle2(col)] : '');
              }
            } else if (col.includes('subscription')) {
              item.push(remote?.subscription && isColVisible ? remote?.subscription?.[this.colEle2(col)] : '');
            } else if (col.includes('metrics')) {
              item.push(remote?.metrics && isColVisible ? remote?.metrics?.[this.colEle2(col)] : '');
            } else if (col.includes('network')) {
              item.push(remote?.network && isColVisible ? remote?.network?.[this.colEle2(col)] : '');
            } else {
              item.push(isColVisible ? remote[col] : '');
            }
          });
          dataToExport.push(item);
        });
      }
      return dataToExport;
    },
    remapRemoteHeadersForExport() {
      return this.activeTableVisibleColumns.map(c => c.value);
    },
    getAccountNameFromId(id) {
      const account = this.$store.state.accounts.accounts.find(a => a.id == id);
      return account ? account.name : null;
    },
    colEle2(col) {
      if (col) {
        const splitArray = col.split('.');
        if (splitArray.length == 2) return splitArray[1];
      }
      return '';
    },
    async exportRemotes() {
      const headers = await this.remapRemoteHeadersForExport();
      const remotes = await this.remapRemotesForExport();
      if (!remotes) return;
      this.exportCsvArray(headers, remotes, 'remotes');
      // KyAnalytics client plugin, event tracker
      this.$kya.event('remotes', 'exportRemotesList', 'Export remotes list');
      // eslint-disable-next-line consistent-return
      return true;
    },
    isSortable(columnName) {   
      if (columnName == 'provisioned' || columnName == 'activated' || columnName == 'devices.antennaSoftwareVersion' || columnName == 'devices.antennaTargetVersion' || columnName == 'subscription.hasSatellite' || columnName == 'subscription.hasCellular' || columnName == 'devices.terminalModel' || columnName == 'devices.modemModel' || columnName == 'devices.cellRouterModel' || columnName == 'groupNames') return false;
      return true;
    },
    isCentered(columnName) {
      if (columnName == 'provisioned' || columnName == 'activated' || columnName == 'metrics.satDataUsed' || columnName == 'subscription.maxDataLimitInGb' || columnName == 'metrics.cellDataUsed' || columnName == 'subscription.hasSatellite' || columnName == 'subscription.hasCellular') return true;
      return false;
    },
    cellClass(columnName) {
      if (columnName == 'satelliteOnline' || columnName == 'cellularOnline') return 'is-35';
      if (columnName == 'provisioned' || columnName == 'activated' || columnName == 'subscription.hasSatellite' || columnName == 'subscription.hasCellular') return 'is-100';
      if (columnName == 'devices.modemSerial') return 'is-140';
      if (columnName == 'subscription.maxDataLimitInGb' || columnName == 'metrics.cellDataUsed' || columnName == 'metrics.satDataUsed') return 'is-160';
      if (columnName == 'devices.modemModel' || columnName == 'devices.cellRouterModel') return 'is-170 truncate';
      if (columnName == 'normalizedBilledAccountName' || columnName == 'devices.terminalModel') return 'is-180 truncate';
      if (columnName == 'devices.antennaSoftwareVersion' || columnName == 'devices.antennaTargetVersion' || columnName == 'devices.antennaLastCheckin' || columnName == 'devices.cellRouterSerial' || columnName == 'devices.cellRouterICCID') return 'is-200';
      if (columnName == 'groupNames') return 'is-200 truncate';
      if (columnName == 'normalizedName') return 'is-330 truncate';
      return '';
    },
    hasWidth(columnName) {
      if (columnName == 'satelliteOnline' || columnName == 'cellularOnline') return "35";
      return "100%";
    },
    matchingSortBy(columnName) {
      if (columnName == 'devices.modemSerial') return 'Devices/ModemSerial'; 
      if (columnName == 'devices.antennaLastCheckin') return 'Devices/AntennaLastCheckin'; 
      if (columnName == 'devices.cellRouterSerial') return 'Devices/CellRouterSerial';
      if (columnName == 'devices.cellRouterICCID') return 'Devices/CellRouterICCID'; 
      if (columnName == 'metrics.satDataUsed') return 'Metrics/SatDataUsed';
      if (columnName == 'subscription.maxDataLimitInGb') return 'Subscription/MaxDataLimitInGb';
      if (columnName == 'metrics.cellDataUsed') return 'Metrics/CellDataUsed';
      return columnName.charAt(0).toUpperCase() + columnName.slice(1);
    },
    ifUsageExceedsLimit(used, limit) {
      // if we don't have values to work with, show warning
      if (!!limit || !!used) return 'has-text-warning';
      // convert limit to bytes
      const limitInB = limit * 1000 * 1000 * 1000;
      // compare
      if (!!limitInB && (used > limitInB)) return 'has-text-danger';
      return '';
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setContextPane', null);
    next();
  }
}
</script>
<style lang="scss" scoped>
.kpt-remotes-root {
  position: relative;
  height: 100%;

  ::v-deep .loading-overlay {
    z-index: 9;
  }

  .kpt-list-table {
    width: 100%;
  }
}
</style>
